import React, { Component } from 'react';
import ForgotPasswordComponent from '../components/forgotPasswordComponents';
import {getCompanyBrandingList,ResetUserPassword2 ,ResetUserPasswordRequest1,ResetUserPassword1,FetchUserPasswordRequest1,ResetUserPasswordRequest2,FetchUserPasswordRequest,FetchUserPasswordRequest2} from '../actions/forgotPasswordAction'
import { loggedIn, logOutUser, getProfile, logout } from '../../Login/actions/loginAction'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'

class ForgotPasswordContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            user: ""
        }
          this.props.actions.getCompanyBrandingList();
        this.ResetPassword = this.ResetPassword.bind(this)
        this.ResetPassword2 = this.ResetPassword2.bind(this)
        logout();
        this.props.actions.logOutUser();
    }

    componentWillMount() {
        this.props.actions.getCompanyBrandingList(this.props.dispatch);
            
        this.props.actions.FetchUserPasswordRequest1(
            this.props.dispatch
        )
         this.props.actions.FetchUserPasswordRequest2(
            this.props.dispatch
        )
    }

    ResetPassword(username) {
        this.props.actions.ResetUserPassword1(
            username,           
            this.props.dispatch)
    }
    ResetPassword2(username) {
        this.props.actions.ResetUserPassword2(
            username,           
            this.props.dispatch)
    }

   

    render() {
        return (
                <div> 
                    <ForgotPasswordComponent 
                        ResetPassword={this.ResetPassword} 
                        ResetPassword2={this.ResetPassword2}
                        loginDet={this.props.login}
                        forgotPassword={this.props.forgotPassword}
                        >
                    </ForgotPasswordComponent>
                </div>
            )

    }

}

function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            ResetUserPassword1, logOutUser,ResetUserPasswordRequest1,
            FetchUserPasswordRequest1,getCompanyBrandingList,ResetUserPassword2,ResetUserPasswordRequest2,
            FetchUserPasswordRequest2
        },
            dispatch)
    };
}

function mapStateToProps({ loginReducer,forgotPasswordReducer }) {
    return {
        login: {
            userName: loginReducer.userName,
            isLoading: loginReducer.isLoading,
            password: loginReducer.password,
            Message: loginReducer.Message,
            loginStatus: loginReducer.loginStatus,
            authTokenId: loginReducer.authTokenId,
            userId: loginReducer.userId,
            statusCode:loginReducer.statusCode,
            errorCode:loginReducer.errorCode,
            errorMessage:loginReducer.errorMessage,
        },
        forgotPassword:{
           isLoading: forgotPasswordReducer.isLoading, 
           statusCode:forgotPasswordReducer.statusCode,
           errorMessage:forgotPasswordReducer.errorMessage,
           brandList: forgotPasswordReducer.brandList,
           requestForgotPasswordDetail:forgotPasswordReducer.requestForgotPasswordDetail,
           verifyStatusCode:forgotPasswordReducer.verifyStatusCode
        }
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordContainer))
